import { IStyles } from '../models/app/IStyles';

export const STYLES: IStyles = {
	components: {
		app: {
			children: {
				example: {},
				wrapper: {
					background: {
						color: '#F5F6F7',
					},
					padding: {
						_value: '0 0 15px 0',
					},
				},
			},
		},
		fundManagerCard: {
			children: {
				wrapper: {
					background: {
						color: '#FFFFFF',
					},
					box: {
						shadow: '0 2px 4px 0 rgba(0,0,0,0.08);',
					},
					display: 'inline-block',
					margin: {
						bottom: '5px',
						top: '2px',
					},
					padding: {
						bottom: '20px',
						top: '19px',
					},
					text: {
						align: 'center',
					},
					width: '237px',
				},
			},
		},
		image: {
			children: {
				wrapper: {
					border: {
						color: '#ccc',
						radius: '50%',
						style: 'solid',
						width: '2px',
					},
					height: '155px',
					margin: {
						_value: '0 auto',
						bottom: '20px',
					},
					overflow: {
						_value: 'hidden',
					},
					width: '155px',
					overrides: [
						{
							selector: 'img',
							style: {
								width: '155px',
							},
						},
					],
				},
			},
		},
		name: {
			children: {
				nameText: {
					font: {
						size: '14px',
						weight: 'bold',
					},
					lineHeight: '14px',
					margin: {
						bottom: '10px',
					},
					text: {
						align: 'center',
					},
				},
			},
		},
		title: {
			children: {
				titleText: {
					color: '#888888',
					font: {
						size: '12px',
					},
					lineHeight: '18px',
					margin: {
						bottom: '15px',
					},
					text: {
						align: 'center',
					},
				},
			},
		},
		bio: {
			children: {
				bioText: {
					max: {
						height: '155px',
					},
					overflow: {
						y: 'scroll',
					},
				},
			},
		},
		definitionList: {
			children: {
				wrapper: {
					color: '#888888',
					font: {
						size: '12px',
					},
					lineHeight: '18px',
					margin: {
						bottom: '15px',
					},
					text: {
						align: 'center',
					},
				},
			},
		},
		overlay: {
			children: {
				overlayCard: {
					position: 'absolute',
					background: {
						color: 'white',
					},
					width: '100%',
					height: '100%',
					left: '0px',
					top: '0px',
					max: {
						height: '350px',
					},
					overflow: {
						y: 'scroll',
					},
				},
				closeButton: {
					position: 'absolute',
					top: '5px',
					right: '5px',
				},
			},
		},
	},
	theme: {
		base: {
			button: {
				background: {
					color: '#ffffff',
				},
				border: {
					_value: 'none',
				},
				color: '#0075BE',
				cursor: 'pointer',
				font: {
					family: 'inherit',
					size: '13px',
					weight: 'bold',
				},
				lineHeight: '19px',
				text: {
					align: 'center',
					transform: 'uppercase',
				},
			},
			card: {
				children: {
					header: {
						display: 'flex',
						justifyContent: 'center',
					},
					subtitle: {
						color: '#5F5F5F',
						font: {
							size: '16px',
							weight: '400',
						},
					},
					title: {
						color: '#001928;',
						font: {
							size: '24px',
							weight: '300',
						},
						lineHeight: '29px',
						margin: {
							_value: '0 0 1em 0',
						},
						width: '237px',
					},
				},
				font: {
					family: 'Heebo, Helvetica, Arial, sans-serif',
				},
				lineHeight: '24px',
			},
			carousel: {
				children: {
					componentWrapper: {
						text: {
							align: 'center',
						},
						transition: {
							_value: 'all 300ms ease-in-out',
						},
					},
					components: {
						width: '237px !important',
					},
					content: {
						align: {
							items: 'center',
						},
						display: 'flex',
						justifyContent: 'center',
						position: 'relative',
						width: '237px',
					},
					dot: {
						border: {
							_value: '2px solid #929BA9',
							radius: '50%',
						},
						box: {
							sizing: 'border-box',
						},
						conditionals: [
							{
								conditional: {
									conditions: [
										{
											field: 'selected',
											operator: '=',
											value: true,
										},
									],
								},
								style: {
									background: {
										color: '#0075BD',
									},
									border: {
										_value: 'none',
									},
									height: '11px',
									width: '11px',
								},
							},
						],
						height: '9px',
						width: '9px',
					},
					dotWrapper: {
						padding: {
							left: '2px',
							right: '2px',
						},
					},
					dots: {
						align: {
							items: 'center',
						},
						display: 'flex',
						justifyContent: 'center',
						transform: 'translateY(5px)',
					},
					navWrapper: {
						background: {
							color: '#FFFFFF',
						},
						box: {
							'shadow': '0 2px 2px 0 rgba(0,25,40,0.2)',
						},
						cursor: 'pointer',
						flex: {
							grow: '0',
						},
						height: '64px',
						padding: {
							_value: '4px',
						},
						position: 'absolute',
						selectors: {
							':first-of-type': {
								border: {
									radius: '16px 8px 8px 16px',
								},
								'left': '-25px',
							},
							':last-of-type': {
								border: {
									radius: '8px 16px 16px 8px',
								},
								right: '-25px',
							},
						},
						width: '48px',
						zIndex: '2',
					},
					wrapper: {
						align: {
							items: 'center',
						},
						display: 'flex',
						flex: {
							direction: 'column',
						},
						justifyContent: 'center',
						overrides: [
							{
								selector: '[data-selector="base-carousel-nav"]',
								style: {
									align: {
										items: 'center',
									},
									display: 'flex',
									height: '64px',
									justifyContent: 'center',
								},
							},
							{
								selector: '[data-selector="base-carousel-nav"] > [data-selector="base-image"]',
								style: {
									height: '24px',
								},
							},
						],
					},
				},
			},
			grid: {
				children: {
					column: {
						display: 'flex',
						flex: {
							direction: 'column',
						},
					},
					component: {},
					row: {
						display: 'flex',
						flex: {
							direction: 'row',
						},
						justifyContent: 'center',
					},
					wrapper: {},
				},
			},
			text: {
				children: {
					content: {
						margin: {
							_value: '0 0 1em 0',
						},
					},
				},
				color: '#001928',
				font: {
					size: '16px',
				},
			},
		},
		management: {

		},
	},
};
